import React from "react";
import { routes } from "../../lib/config/routes";
import DashboardIcon from "../../assets/dashboard";
import ProjectsIcon from "../../assets/projects";
import LeadsIcon from "../../assets/leads";
import CallsIcon from "../../assets/calls";
import AppointmentIcon from "../../assets/appointments";
import SettingsIcon from "../../assets/settings";

export const menuItems = [
  {
    name: "Dashboard",
    href: routes.dashboard,
    icon: <DashboardIcon className={"color:bg-secondary"} />,
  },
  {
    name: "Campaigns",
    href: routes.campaigns,
    icon: <ProjectsIcon className={"color:bg-secondary"} />,
  },
  {
    name: "Calls",
    href: routes.calls,
    icon: <CallsIcon className={"color:bg-secondary"} />,
  },
  {
    name: "Contacts",
    href: routes.leads,
    icon: <LeadsIcon className={"color:bg-secondary"} />,
  },
  {
    name: "Appointments",
    href: routes.appointments,
    icon: <AppointmentIcon className={"color:bg-secondary"} />,
  },
  {
    name: "Knowledge base",
    href: routes.knowledgebase,
    icon: <ProjectsIcon className={"color:bg-secondary"} />,
  },
  {
    name: "Settings",
    href: routes.settings,
    icon: <SettingsIcon className={"color:bg-secondary"} />,
  },
];
